module.exports = __webpack_public_path__ + "static/media/10-EntreVestors.339dbff3.png";